import { Form } from 'antd';
import { useAppSelector } from 'app/hooks';
import { ReactComponent as PlacementStaplesLandscapeLength } from 'assets/img/placement-staples-landscape-length.svg';
import { ReactComponent as PlacementStaplesLandscapeWidth } from 'assets/img/placement-staples-landscape-width.svg';
import { ReactComponent as PlacementStaplesPortraitLength } from 'assets/img/placement-staples-portrait-length.svg';
import { ReactComponent as PlacementStaplesPortraitWidth } from 'assets/img/placement-staples-portrait-width.svg';
import { RevxRadio } from 'components';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { BINDING_EDGE_ENUM } from 'domains/jobconfigDomain';
import { OrientationEnum } from 'domains/skuDomain';
import { useMemo } from 'react';
import { getSelectedSpecItem } from 'utils/jobConfig';
import { ConfigSvcProps } from '..';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcOption from '../common/CommonJobSvcOption';

const BookletsSaddleStitched = (props: ConfigSvcProps) => {
  const { id, jobOptionSvc } = props;
  const configItem = useAppSelector((state) => state.jobConfig.configItem);
  const spec = getSelectedSpecItem(configItem)?.spec;
  const svcOption = useMemo(() => {
    return {
      bindingEdge: jobOptionSvc?.options?.find(
        (option) => option.label === 'Binding Edge'
      ),
      otherOption: jobOptionSvc?.options?.filter(
        (option) => option.label !== 'Binding Edge'
      ),
    };
  }, [jobOptionSvc]);
  const bindingSaddleRadioProps: RevxRadioProps = {
    outSideRevxLayoutProps: {
      align: 'bottom',
      justify: 'left',
      className:
        'jobconfig-jobOption-content-outSideOption jobconfig-jobOption-content-binding',
    },
    inSideRevxLayoutProps: {
      align: 'center',
      className: 'jobconfig-jobOption-content-inSideOption',
    },
    iconSequence: 'last',
    options: [
      {
        value: BINDING_EDGE_ENUM['Long Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <>
              {spec?.orientation === OrientationEnum.landscape ? (
                <PlacementStaplesLandscapeWidth
                  style={{ width: 116, height: 87 }}
                />
              ) : (
                <PlacementStaplesPortraitLength />
              )}
            </>
            <label>Long-edge</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_EDGE_ENUM['Short Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <>
              {spec?.orientation === OrientationEnum.landscape ? (
                <PlacementStaplesLandscapeLength
                  style={{ width: 116, height: 87 }}
                />
              ) : (
                <PlacementStaplesPortraitWidth />
              )}
            </>
            <label>Short-edge</label>
          </RevxFlexLayout>
        ),
      },
    ].filter((item) => svcOption?.bindingEdge?.values.includes(item.value)),
  };

  return (
    <>
      <div className="jobconfig-jobOption-content-title">
        Booklets: Saddle-stitched
      </div>
      <div className="jobconfig-jobOption-content-subTitle">Binding</div>
      <RevxFlexLayout>
        <Form.Item name={[id, 'Binding Edge']}>
          <RevxRadio {...bindingSaddleRadioProps} />
        </Form.Item>
        <CommonJobSvcOption
          {...props}
          customerOptions={svcOption?.otherOption}
        />
      </RevxFlexLayout>
      {/* <CommonQuantityPerBundle {...props} /> */}
      <CommonJobSvcInstructions {...props} />
      <CommonJobSvcMessage {...props} />
      <div className="jobconfig-jobOption-content-border"></div>
    </>
  );
};

export default BookletsSaddleStitched;
